<template>
  <content class="integral-content">
    <el-row>
      <el-form
        :inline="true"
        :model="searchCondition"
        class="demo-form-inline"
        label-width="120px"
        size="small"
      >
        <!-- <el-form-item label="站点名称">
          <el-input
            v-model="searchCondition.user"
            placeholder="审批人"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="兑换类型">
          <el-select v-model="searchCondition.type" placeholder="活动区域">
            <el-option label="积分兑换" value="1"></el-option>
            <el-option label="积分抵扣" value="2"></el-option>
            <el-option label="后台变更" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="积分使用类别">
          <el-select v-model="searchCondition.useStatus" placeholder="使用类别">
            <el-option label="查询本站使用联盟积分" value="0"></el-option>
            <el-option label="查询联盟使用本站积分" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查询区间">
          <el-date-picker
            v-model="dateValue[0]"
            @change="cacheTime(1)"
            type="date"
            class="timeInput"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
          <el-time-picker
          @change="cacheTime(2)"
            placeholder="时间"
            v-model="timeValue[0]"
            class="timeInput"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            size="small"
          ></el-time-picker>
          <span style="margin-right:8px">至</span>
          <el-date-picker
          @change="cacheTime(1)"
            v-model="dateValue[1]"
            type="date"
            class="timeInput"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
          <el-time-picker
          @change="cacheTime(2)"
            placeholder="时间"
            v-model="timeValue[1]"
            class="timeInput"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            size="small"
          ></el-time-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPointList()">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-col :span="8" class="add-oil">
        <el-select
          @change="changeLabel"
          class="xz-options"
          v-model="oil_str"
          placeholder="选择油站"
        >
          <el-option
            v-for="item in selectArr"
            :key="item.alliance_app_id"
            :label="item.alliance_room"
            :value="item.alliance_app_id"
          ></el-option>
        </el-select>
      </el-col> -->
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        style="width: 100%;margin-top:20px"
      >
        <el-table-column prop="mobile" label="会员手机号"></el-table-column>
        <el-table-column prop="ordersn" label="订单号"></el-table-column>
        <el-table-column prop="app_room" label="门店名称"></el-table-column>
        <el-table-column
          prop="alliance_room"
          label="联盟门店名称"
        ></el-table-column>
        <el-table-column prop="num" label="使用积分数量"></el-table-column>
        <el-table-column label="积分类型">
          <template slot-scope="scope">{{
            scope.row.type | now_status
          }}</template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
      </el-table>
      <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
    </el-row>
  </content>
</template>
<script>
import { Button, Slider } from "element-ui";
import {
  getPointLogs,
  cancelAlliance,
  addAlliance,
  getLianceList
} from "@/api/merchant";
import { mapGetters } from "vuex";
export default {
  components: {
    Button,
    Slider
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  filters: {
    now_status: function(val) {
      switch (val) {
        case 1:
          return "积分兑换 ";
        case 2:
          return "积分抵扣";
        case 3:
          return "后台变更";
        default:
          break;
      }
    }
  },
  data() {
    return {
      searchCondition: {
        type: "",
        start_time: "",
        end_time: "",
        use: "",
        used: 0, // 查询本站使用联盟积分 0,查询联盟使用本站积分 1
        useStatus: "0"
      },
      total: 0,
      page: 1,
      visible: false,
      // 0邀请中 1联盟成立 2联盟拒绝 3联盟结束
      top_nav: [
        {
          id: 0,
          name: "油站",
          num: 10
        },
        {
          id: 1,
          name: "本站消耗他站积分",
          num: 100
        },
        {
          id: 2,
          name: "他站消耗本站积分",
          num: 300
        }
      ],
      tableData: [],
      loading: true,
      value: [],
      oil_str: "",
      selectArr: [],
      options: [
        {
          value: 0,
          label: "邀请中"
        },
        {
          value: 1,
          label: "联盟成立"
        },
        {
          value: 2,
          label: "联盟拒绝"
        },
        {
          value: 3,
          label: "联盟结束"
        }
      ],
      dateValue: [],
      timeValue: []
    };
  },
  created() {
    this.getPointList();
    // this.getSelectArr();
  },
  methods: {
    handleCurrentChange(p) {
      this.page = p;
      this.getPointList();
    },
    cacheTime(i) {
      if (i == 1) {
        var dateCache = this.dateValue.join(",");
        sessionStorage.setItem("dateCache", dateCache);
      } else {
        var timeCache = this.timeValue.join(",");
        sessionStorage.setItem("timeCache", timeCache);
      }
    },
    changeLabel(arr) {
      this.getPointList(arr.toString());
    },
    // 获取所有联盟
    // async getSelectArr() {
    //   try {
    //     const data = { token: this.token, app_id: this.app_id };
    //     const res = await getLianceList(data);
    //     if (res.code === 200) {
    //       this.selectArr = res.data;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async getPointList() {
      try {
        this.loading = true;
        if (sessionStorage.getItem("dateCache")) {
          this.dateValue = sessionStorage.getItem("dateCache").split(",");
        }
        if (sessionStorage.getItem("timeCache")) {
          this.timeValue = sessionStorage.getItem("timeCache").split(",");
        }
        console.log("日期时间！！", this.dateValue,this.timeValue);
        const data = {
          token: this.token,
          app_id: this.app_id,
          type: this.searchCondition.type,
          page: this.page,
          alliance_app_id: this.$route.query.alliance_app_id
        };
        if (this.searchCondition.useStatus == 0) {
          data.use = 1;
        } else {
          data.used = 1;
        }
        if( this.dateValue.length == 2 &&  this.timeValue.length == 2 &&  this.dateValue[0] !== ''){
          data.start_time = this.timeValue[0]? this.dateValue[0] + " " + this.timeValue[0]:this.dateValue[0] + " 00:00:00"
          data.end_time = this.timeValue[1]? this.dateValue[1] + " " + this.timeValue[1]:this.dateValue[1] + " 23:59:59"
        }
        const res = await getPointLogs(data);
        if (res.code === 200) {
          if (res.data.total > 0) {
            this.page = res.data.current_page
            this.total = res.data.total
            this.tableData = res.data.data;
            this.loading = false;
          } else {
            this.tableData = [];
            this.$message.error("暂无数据...");
            this.loading = false;
          }
        } else {
          throw res;
        }
      } catch (error) {
        this.tableData = [];
        this.$message.error(res.msg);
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// 时间框长度
.timeInput{
  width: 140px;
}
.integral-content {
  padding: 0 10px;
}
.integral-com {
  width: 100%;
  height: 80px;
  display: flex;
  font-size: 18px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 40px;
  border-right: 1px solid #fff;
  background-color: #f3f3f3;
}
.integral-com:nth-child(3) {
  border-right: none;
}
.add-oil {
  width: 100%;
  margin: 20px 0;
}
.bot-pagination {
  float: right;
  margin-top: 20px;
}
.xz-options {
  width: 300px;
  // margin-left: 20px;
}
</style>
